<template>
    <b-modal
        :visible="isOpen"
        @hidden="close"
        lazy
        title-tag="h2"
        title="Preview Result"
        ok-title="Assign To Record"
        @ok="assignToRecord()"
        footer-class="d-flex justify-content-between"
        size="lg"
    >
        <div v-if="record">
            <b-row class="d-flex align-items-start mb-2">
                <b-col cols="3">
                    <b>Lab:</b>
                </b-col>
                <b-col v-html="properTestName(record)"> </b-col>
            </b-row>
            <b-row class="d-flex align-items-start mb-2">
                <b-col cols="3">
                    <b>Patient:</b>
                </b-col>
                <b-col>
                    {{ properPatientName(record) }}
                </b-col>
            </b-row>
            <div class="mt-4"></div>
            <table
                v-for="(test, index) in results"
                :key="index"
                class="table b-table list table-hover table-borderless preview-result-table"
            >
                <thead>
                    <tr class="test-name">
                        <th colspan="4">
                            {{ test.test_name }}
                            <div v-if="test.message" class="font-weight-normal">
                                {{ test.message }}
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th width="20%">Test:</th>
                        <th>Result:</th>
                        <th class="text-nowrap">Reference Range:</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody
                    v-for="(item, iindex) in test.test_results"
                    :key="iindex"
                >
                    <tr :class="{ 'border-bottom-0': item.comment }">
                        <td>
                            <b>{{ item.test_name }}</b>
                        </td>
                        <td v-html="item.value"></td>
                        <td v-html="item.range"></td>
                        <td>
                            <lab-reference-range
                                v-if="isNumeric(item) && item.show_bar"
                                :percentage="item.pct"
                            />
                        </td>
                    </tr>
                    <tr v-if="item.comment" class="border-top-0">
                        <td></td>
                        <td colspan="3" v-html="decodeHtml(item.comment)"></td>
                    </tr>
                </tbody>
                <tbody>
                    <tr
                        v-for="(comment, cindex) in test.test_comments"
                        :key="cindex"
                    >
                        <td>
                            <b>{{ comment.test_name }}</b>
                        </td>
                        <td colspan="3" v-html="comment.comment"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>
<style type="text/css" lang="scss">
.preview-result-table {
    border-top: 1px solid #ddd;
    margin-bottom: 0px;

    .test-name {
        background: rgba(201, 204, 222, 0.3);
    }

    tr.border-bottom-0 {
        border-bottom: 0px;

        td {
            border-bottom: 0px;
        }
    }

    tr.border-top-0 {
        border-top: 0px;

        td {
            border-top: 0px;
        }
    }
}
</style>
<script>
import Lab from "@/services/lab";
import LabReferenceRange from "@/components/commons/lab-reference-range";


export default {
    components: {
        LabReferenceRange
    },
    data() {
        return {
            isOpen: false,
            record: null,
            results: [1, 2, 3, 4]
        };
    },
    methods: {
        open(record) {
            this.record = record;
            this.isOpen = true;

            this.getLabResults(record);
        },
        isNumeric(test) {
            return test.type ? test.type.toUpperCase() === "NUMERIC" : false;
        },
        getLabResults(record) {
            let source = record.source ? record.source : record.module;
            source = source.toUpperCase();
            Lab.getResults(source, record.id).then(response => {
                this.results = response;
            });
        },
        close() {
            this.isOpen = false;
        },
        assignToRecord() {
            this.$emit("assign", this.record);
        },
        properTestName(record = {}) {
            let testName = "";
            let serviceURL = this.CIAPPS;

            switch (record.module) {
                case "onprem":
                    if (Object.keys(record.test).length > 0) {
                        testName = record.test.name;

                        if (record.test.item) {
                            testName =
                                '<a href="' +
                                serviceURL +
                                "inventory/item/view/" +
                                record.test.item.encodedId +
                                '">' +
                                testName +
                                "</a>";
                        }
                    }

                    if (record.analyzerType) {
                        testName = record.source + ": " + record.analyzerType;
                    }
                    break;

                case "abaxis_api":
                case "abaxis_fuse":
                    if (record.test && Object.keys(record.test).length > 0) {
                        testName = record.test.name;

                        if (record.test.encodedId) {
                            testName =
                                '<a href="' +
                                serviceURL +
                                "inventory/item/view/" +
                                record.test.encodedId +
                                '">' +
                                testName +
                                "</a>";
                        }
                    }
                    break;
                case "lab":
                    if (record.result && record.result.item) {
                        testName = record.result.item.name;
                        if (record.result.item.encodedId) {
                            testName =
                                '<a href="' +
                                serviceURL +
                                "inventory/item/view/" +
                                record.result.item.encodedId +
                                '">' +
                                testName +
                                "</a>";
                        }
                    } else if (Object.keys(record.result).length > 0) {
                        var provider = record.reference_type.replace(/_/g, " ");
                        provider = provider
                            .toLowerCase()
                            .replace(/\b[a-z]/g, function (letter) {
                                return letter.toUpperCase();
                            });

                        if (record.result_reference_id != null) {
                            testName =
                                provider +
                                ": " +
                                record.result.name +
                                " #" +
                                record.result_reference_id;
                        } else {
                            testName = provider + ": " + record.result.name;
                        }
                    }
                    break;

                case "idexx":
                case "znlabs":
                case "midwest":
                case "nbiovet":
                case "vetek":
                case "microvet":
                case "bionote":
                case "heska":
                case "abaxis":
                case "heska_cloud":
                    if (Object.keys(record.test).length > 0) {
                        let itemName = "";
                        testName = "";

                        $.each(record.test, function (key, value) {
                            if (value.item) {
                                if (value.item.name) {
                                    itemName = value.item.name;
                                    testName +=
                                        '<div><a href="' +
                                        serviceURL +
                                        "inventory/item/view/" +
                                        value.item.encodedId +
                                        '">' +
                                        itemName +
                                        "</a></div>";
                                } else if (value.item.master_name) {
                                    itemName = value.item.master_name;
                                    testName += "<div>" + itemName + "</div>";
                                } else if (value.item.code_name) {
                                    itemName = value.item.code_name;
                                    testName += "<div>" + itemName + "</div>";
                                }
                            }
                        });
                    }
                    break;
                case "antech":
                    if (record.test && record.test.length > 0) {
                        testName = record.test;
                    }
                    break;
                default:
                    break;
            }

            return testName;
        },
        properPatientName(record = {}) {
            let patient = record.patient;
            let animalName = record.animal_name;
            let animalId = record.animal_id;

            if (patient && patient.name) {
                return patient.index
                    ? `${patient.name} (${patient.index})`
                    : patient.name;
            }

            if (animalName && animalId) {
                return `${animalName} (${animalId})`;
            }

            if (patient && patient.index) {
                return patient.index;
            }

            return null;
        },
        decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        }
    }
};
</script>
